import { config } from '@optimex-xyz/trade-wallet-sdk'

import { SUPPORTED_NETWORK } from '@/utils'

import { Contract, ethers, Interface, Signer, Wallet } from 'ethers'

import SpokePoolAbi from './abis/spoke-pool.json'

const depositV3Interface = new Interface(SpokePoolAbi)

export const getSpokePoolContract = async (
  network: SUPPORTED_NETWORK,
  signerOrProvider?: Wallet | Signer
): Promise<Contract> => {
  const spokePoolAddress = config.getSpokePoolAddressByNetwork(network)
  if (!spokePoolAddress) throw new Error('Across Spoke Pool is undefined. Missing configuration!')

  return new ethers.Contract(spokePoolAddress, depositV3Interface, signerOrProvider)
}
